export function openWhatsapp(phone, text) {
    window.open(`https://api.whatsapp.com/send?${phone ? `phone=${phone}` : ""}&text=${text}`)
}

export function getWhatsappURL(phone, text) {
    return `https://api.whatsapp.com/send?${phone ? `phone=${phone}` : ""}&text=${text}`
}